// 顾客的小仓库
const state = {
  routeFrom: '',
  address_id: ''
};
const mutations = {
  updateRouteFrom(state, routeFrom){
    state.routeFrom = routeFrom
  },
  updateAddressId(state, address_id){
    state.address_id = address_id
  }
};
const actions = {
};
const getters = {};

export default {state, actions,mutations,getters}